// Shared list/panel props for Plan page rail panels.
export const PANEL_FLAT_CLASS = 'panel-flat-list';

/** Panel headers stay clickable but out of tab order; task lists are the tab stops. */
export const PLAN_PANEL_A11Y = { headerTabIndex: -1 };

export const planRailListTabProps = (tasks) => ({
  listTabIndex: tasks?.length > 0 ? 0 : -1,
  itemTabIndex: -1,
});

export const railListProps = {
  view: 'plan',
  menuSurface: 'plan-rail',
  showBreadcrumbs: true,
  dragEnabled: true,
  disableStructuralNav: true,
};
